import { http8010 } from "config/http8010";

export const getDataByHostURL = async (URL: any, from_date: string, to_date: string, code: any, fileType: string) => {
    try {
        if (fileType !== "") {
            const res: any = await http8010.get(code === "" ? `get_data_by_hosturl?hosturl=${URL}&start_date=${from_date}&end_date=${to_date}&file_type=${fileType}` : `get_data_by_hosturl?hosturl=${URL}&start_date=${from_date}&end_date=${to_date}&file_status=${code}&file_type=${fileType}`)
            return { result: res?.data }
        } else {
            const res: any = await http8010.get(code === "" ? `get_data_by_hosturl?hosturl=${URL}&start_date=${from_date}&end_date=${to_date}` : `get_data_by_hosturl?hosturl=${URL}&start_date=${from_date}&end_date=${to_date}&file_status=${code}`)
            return { result: res?.data }
        }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getDownloadFile = async (file_path: any) => {
    try {
        const res: any = await http8010.get(`download?file_path=${file_path}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}